// extracted by mini-css-extract-plugin
module.exports = {"cover":"styles_cover__SJr_c","loader":"styles_loader__mih0v","l7":"styles_l7__Gfn_H"};